import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface RequireAuthProps {
  children: ReactNode;
}

/** Redirige a login si no hay sesión (evita volver con el botón Atrás tras cerrar sesión). */
const RequireAuth = ({ children }: RequireAuthProps) => {
  const authToken = localStorage.getItem("authToken");
  if (!authToken) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
